export default "__VITE_ASSET__47cc6b86__"